/*# sourceMappingURL=collaboration-content.component-QZDFRXDB.css.map */
